import { render, staticRenderFns } from "./VideoEmbed.vue?vue&type=template&id=f2f2e5fe"
import script from "./VideoEmbed.vue?vue&type=script&lang=js"
export * from "./VideoEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2f2e5fe')) {
      api.createRecord('f2f2e5fe', component.options)
    } else {
      api.reload('f2f2e5fe', component.options)
    }
    module.hot.accept("./VideoEmbed.vue?vue&type=template&id=f2f2e5fe", function () {
      api.rerender('f2f2e5fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/shortcodes/VideoEmbed.vue"
export default component.exports